import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  return (
    <>
    {/* Footer */}
        <footer className="relative z-10 bg-black text-white text-center py-4 footer-wrapper">
            <div className="container mx-auto">
            <p>&copy; {year} Family Fun Arizona. All Rights Reserved.</p>
            <div className="flex justify-center space-x-4 mt-2">
                {/* <a
                href="/"
                className="text-white hover:underline transition-colors"
                >
                About Us
                </a> */}
                <Link
                to="/contact-us"
                className="text-white hover:underline transition-colors"
                >
                Contact Us
                </Link>
                <Link
                to="/refund-policy"
                className="text-white hover:underline transition-colors"
                >
                Refund Policy
                </Link>
            </div>
            </div>
        </footer>
    </>
  )
}

export default Footer